module.exports = __webpack_public_path__ + "assets/img/index-box2-2.521acf8a.png";